import React from 'react'
import { Redirect } from 'react-router-dom'

const FormEndPoint = ({ match: { params: { orderID } } }) => (
  <Redirect to={`/form/${orderID}/pickup`}/>
)

export default FormEndPoint
